enum ActionType {
    REQUEST_USERS = '[CORE/USERS] GET USERS',
    SET_USERS = '[CORE/USERS] SET USERS',
}

export default ActionType
